import { useEffect } from 'react';
import { dispatchAction } from '@ardoq/rxbeach';
import { endTour, startTour } from '@ardoq/product-tours-host';
import { navigatorTourStarted } from 'presentation/slideNavigator/actions';

type UseAutoStartNavigatorTourArgs = {
  canRunTour: boolean;
  hasSeenTour: boolean;
};

export const useAutoStartNavigatorTour = ({
  canRunTour,
  hasSeenTour,
}: UseAutoStartNavigatorTourArgs): void => {
  useEffect(() => {
    if (!canRunTour) {
      dispatchAction(endTour());
      return;
    }
    if (hasSeenTour) return;
    dispatchAction(navigatorTourStarted());
    dispatchAction(startTour('presentation-navigator'));
  }, [canRunTour, hasSeenTour]);
};
